<template>
    <div class="base-yx-real-name" :class="{'yxrealname-sp': $store.state.screen == 1}">
        <div class="content">
            <div class="title">实名认证</div>
            <div class="tips">根据相关规定，进行网络游戏、交易等行为时需进行实名认证，为给您提供更好的游戏体验，请先进行实名认证。</div>
            <div class="btn">
                <div class="item" @click="onOut">暂不认证</div>
                <div class="item" @click="toRealName">前往认证</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            onOut () {
                this.$emit('childYxRealName', false)
            },
            toRealName () {
                this.$router.push('/base-real-name')
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../static/tctransition";
    $color: #FF6C22; // 主体颜色
    // 横屏css
    .base-yx-real-name {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        transition: all 0.3s;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        .content {
            width: 840px;
            overflow: hidden;
            border-radius: 18px;
            background: $color;
            overflow: hidden;
            padding: 0 60px 60px;
            position: relative;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .title {
                height: 160px;
                font-size: 51px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .tips {
                font-size: 42px;
                margin-bottom: 50px;
            }
            .btn {
                height: 120px;
                margin-top: 55px;
                display: flex;
                justify-content: space-between;
                .item {
                    width: 345px;
                    height: 120px;
                    color: $color;
                    font-size: 39px;
                    border-radius: 18px;
                    background: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .item:first-child {
                    background: rgba(255, 255, 255, 0.8);
                }
            }
        }
    }
    // 竖屏css
    .yxrealname-sp {
        .content {
            width: 1527px;
            border-radius: 32px;
            padding: 0 90px 90px;
            .title {
                height: 290px;
                font-size: 92px;
            }
            .tips {
                font-size: 76px;
                margin-bottom: 90px;
            }
            .btn {
                height: 200px;
                margin-top: 100px;
                .item {
                    width: 627px;
                    height: 200px;
                    font-size: 70px;
                    border-radius: 32px;
                }
            }
        }
    }
</style>